module.exports = "/_next/static/images/delivery_footer-254d6866a3fc30c61de9fe631133de41.png";